document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll('.media--hover-effect');

  cards.forEach(card => {
    const frames = card.querySelectorAll('.hover-frame');
    if (frames.length <= 1) return;

    let index = 0;
    let interval;

    card.addEventListener('mouseenter', () => {
      interval = setInterval(() => {
        frames.forEach(f => f.style.opacity = 0);
        index = (index + 1) % frames.length;
        frames[index].style.opacity = 1;
      }, 900); // rotation speed
    });

    card.addEventListener('mouseleave', () => {
      clearInterval(interval);
      frames.forEach(f => f.style.opacity = 0);
      frames[0].style.opacity = 1; // reset
      index = 0;
    });
  });
});
